<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button type="button" (click)="backToPage()" title="Back">
        <ion-icon name="chevron-back-outline"></ion-icon>&nbsp;Back
      </ion-button>
    </ion-buttons>
    <ion-title>
      <ion-icon name="map"></ion-icon>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button type="button" (click)="nextPage()" title="Next">
        Next&nbsp;<ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" #content>
  <ion-grid class="banner">
    <ion-row>
      <ion-col class="ion-align-self-center margintop"><ion-label class="banner-title">Address Information</ion-label></ion-col>
    </ion-row>
  </ion-grid>
  
  <form [formGroup]="addressForm" class="form form-input margin-top-1rem" *ngIf="accessibleMode!=='VIEW'">
    <ng-container formArrayName="addresses">
    <ion-card *ngFor="let addressForm of addresses.controls;let idx = index" [formGroupName]="idx" class="myChecklist">
      <ion-card-header>
        <ion-grid>
          <ion-row>
            <ion-col></ion-col>
            <ion-col class="text-align-right">
              <!-- <ion-icon name="add-outline" size="small" (click)="addAddress()"></ion-icon> &nbsp;  -->
              <ion-icon name="trash-outline" size="small" *ngIf="idx>0" (click)="removeAddress(idx)"></ion-icon>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card-header>
      <ion-card-content>
        <ion-list>
          <ion-item>
            <ion-select  placeholder="Select a Type" formControlName="type" [ngClass]="accessibleMode==='VIEW' ? 'disabled' : 'uncheckedClass'" required>
                <div slot="label">Type <ion-text color="danger">*</ion-text></div>
                <ion-select-option *ngFor="let addressType of addressTypeList" [value]="addressType" >{{ addressType }}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item *ngIf="addressForm.get('type')?.invalid && addressForm.get('type')?.touched">
            <ion-text color="danger">Type is required</ion-text>
          </ion-item>

          <ion-item>
            <ion-input id="name" type="text" placeholder="Enter the Venue Name"  formControlName="name"
              [ngClass]="accessibleMode==='VIEW' ? 'disabled' : 'uncheckedClass'" maxlength="50">
              <div slot="label">Venue Name<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item *ngIf="addressForm.get('name')?.touched && addressForm.get('name')?.invalid">
            <ion-text *ngIf="addressForm.get('name')?.hasError('required')" color="danger">Venue Name is required</ion-text>
            <ion-text *ngIf="addressForm.get('name')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>

          <ion-item>
            <ion-input id="address" name="address" type="text" placeholder="Enter the Address" maxlength="50"
            formControlName="address" aria-multiline="true" [ngClass]="accessibleMode==='VIEW' ? 'disabled' : 'uncheckedClass'">
            <div slot="label">Address<ion-text color="danger">*</ion-text></div>
          </ion-input>
          </ion-item>
          <ion-item *ngIf="addressForm.get('address')?.invalid && addressForm.get('address')?.touched">
            <ion-text *ngIf="addressForm.get('address')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
            <ion-text *ngIf="addressForm.get('address')?.hasError('required')" color="danger">Address is required</ion-text>
          </ion-item>

          <ion-item>
            <ion-input id="postCode" name="postCode" type="text" maxlength="4" placeholder="Enter the Post Code"
             formControlName="postCode" aria-multiline="true" (change)="setStateByPostcode(addressForm.get('postCode')?.value,idx)"
                [ngClass]="accessibleMode==='VIEW' ? 'disabled' : 'uncheckedClass'">
                <div slot="label">Post Code<ion-text color="danger">*</ion-text></div>
              </ion-input>   
          </ion-item>
          <ion-item *ngIf="addressForm.get('postCode')?.invalid && addressForm.get('postCode')?.touched">
            <ion-text *ngIf="addressForm.get('postCode')?.hasError('pattern')" color="danger">Characters are not allowed</ion-text>
            <ion-text *ngIf="addressForm.get('postCode')?.hasError('required')" color="danger">Post code is required</ion-text>
          </ion-item>

          <ion-item>
            <ion-select  placeholder="Select a State" formControlName="state" (ionChange)="isValidData()" [attr.disabled]="accessibleMode==='VIEW'" required>
              <div slot="label">State <ion-text color="danger">*</ion-text></div> 
              <ion-select-option *ngFor="let state of stateList" [value]="state.stateCode">{{state.stateName}}</ion-select-option>
              </ion-select>              
          </ion-item>
          <ion-item *ngIf="addressForm.get('state')?.invalid && addressForm.get('state')?.touched">
            <ion-text color="danger">State is required</ion-text>
          </ion-item>
          <ion-item>
            <ion-input id="comment" name="comment" label="Comment" type="text" placeholder="Enter the Comment" maxlength="500"
                formControlName="comment" aria-multiline="true" [ngClass]="accessibleMode==='VIEW' ? 'disabled' : 'uncheckedClass'"></ion-input>
          </ion-item>
          <ion-item *ngIf="addressForm.get('comment')?.touched && addressForm.get('comment')?.invalid">
            <ion-text *ngIf="addressForm.get('comment')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>
    <ion-button expand="block" (click)="addAddress()">ADD NEW ADDRESS</ion-button>
    </ng-container>
  </form>

  <ion-grid>
    <ion-row *ngIf="accessibleMode==='VIEW'">
      <ion-col>
        <ion-card *ngFor="let addressItem of addressList; let idx = index"  class="view-mode">
          <ion-card-header>
            <ion-grid class="myChecklist">
              <ion-row>
                <ion-col>
                  <ion-card-title>{{addressItem.name}}</ion-card-title>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="margin-auto">
                  <ion-card-subtitle>{{ addressItem.type }}</ion-card-subtitle>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-header>
      
          <ion-card-content>
            <ion-list>
              <ion-item>
                <ion-label class="item-title">Address</ion-label>
                <ion-label class="item-content" *ngIf="addressItem.address">{{addressItem.address}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!addressItem.address">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Post Code</ion-label>
                <ion-label class="item-content" *ngIf="addressItem.postCode">{{addressItem.postCode}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!addressItem.postCode">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">State</ion-label>
                <ion-label class="item-content" *ngIf="addressItem.state">{{addressItem.state}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!addressItem.state">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Comment</ion-label>
                <ion-label class="item-content" *ngIf="addressItem.comment">{{addressItem.comment}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!addressItem.comment">&lt;empty&gt;</ion-label>
              </ion-item>
            </ion-list>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  
</ion-content>